import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  question: '¿Es un libro físico o digital?',
  answer: 'Digital, acceso inmediato tras la compra, se lee en cualquier dispositivo.'
}, {
  question: '¿Funciona si mi relación ya está en crisis?',
  answer: 'Sí, los scripts y el plan de retirada están diseñados para momentos difíciles.'
}, {
  question: '¿Cuánto tiempo toma ver resultados?',
  answer: 'Muchas mujeres ven cambios desde la primera semana aplicando los scripts.'
}, {
  question: '¿Y si no me funciona?',
  answer: 'El contenido es práctico y accionable, pero cada situación es diferente. Lo importante es que tendrás herramientas claras.'
}, {
  question: '¿Es seguro el pago?',
  answer: 'Sí, procesamos pagos a través de plataformas seguras con encriptación SSL.'
}, {
  question: '¿Puedo leerlo en mi celular?',
  answer: 'Sí, es compatible con cualquier dispositivo: celular, tablet o computadora.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-10 md:py-14 px-6 bg-cream relative" data-id="element-45">
      <div className="max-w-3xl mx-auto" data-id="element-46">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10" data-id="element-47">
          <p className="text-gold font-bold uppercase tracking-widest text-sm mb-3" data-id="element-48">
            Resolvemos tus dudas
          </p>
          <h2 className="text-2xl md:text-4xl font-bold mb-4 text-burgundy" data-id="element-49">
            Preguntas Frecuentes
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-50">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="border border-gold/30 rounded-lg bg-white overflow-hidden shadow-sm" data-id="element-51">
              <button onClick={() => toggleFAQ(index)} className="w-full px-4 py-4 md:px-6 md:py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-52">
                <span className="font-serif font-bold text-burgundy text-base md:text-lg" data-id="element-53">
                  {faq.question}
                </span>
                <motion.div animate={{
              rotate: openIndex === index ? 180 : 0
            }} transition={{
              duration: 0.3
            }} className="text-gold flex-shrink-0 ml-4" data-id="element-54">
                  <ChevronDownIcon className="w-5 h-5" data-id="element-55" />
                </motion.div>
              </button>
              <AnimatePresence data-id="element-56">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-57">
                    <div className="px-4 md:px-6 pb-4 md:pb-5 text-gray-700 text-sm md:text-base leading-relaxed border-t border-gold/10 pt-4" data-id="element-58">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}